import {useEffect, useState} from "preact/hooks";
import QRCode from "react-qr-code";
import {getCouponQrInfo} from "../../data-providers/coupon-data-provider";

const CouponQr = ({token}) => {
    const [loading, setLoading] = useState(true);
    const [showQr, setShowQr] = useState(false);
    const [coupon, setCoupon] = useState(null);
    const [copySuccess, setCopySuccess] = useState(false);

    useEffect(() => {
        setLoading(true);
        getCouponQrInfo(token).then((response) => {
            setCoupon(response.data);
            setLoading(false);
        });
    }, [token]);

    const detailsText = coupon ? [
        `Coupon: ${coupon.coupon_title || "-"}`,
        `Coupon ID: ${coupon.coupon_id || "-"}`,
        `Store: ${coupon.valid_for?.store_name || "-"}`,
        `WhatsApp: ${coupon.valid_for?.store_phone || "-"}`,
        `Verification page: ${coupon.verification_page_url || "-"}`,
    ].join('\n') : '';

    const copyDetails = async () => {
        if (!detailsText) {
            return;
        }
        await navigator.clipboard.writeText(detailsText);
        setCopySuccess(true);
        setTimeout(() => setCopySuccess(false), 2000);
    };

    const shareDetails = async () => {
        if (!navigator.share) {
            await copyDetails();
            return;
        }
        await navigator.share({
            title: coupon?.coupon_title || "Coupon details",
            text: detailsText,
            url: coupon?.verification_page_url || window.location.href,
        });
    };

    if (loading) {
        return <section className={"section"}><div className={"wrapper"}><h2>Loading...</h2></div></section>;
    }

    if (!coupon) {
        return <section className={"section"}><div className={"wrapper"}><h2>Coupon not found</h2></div></section>;
    }

    return (
        <section className={"section"}>
            <div className={"wrapper"} style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                <div style={{background: "#fff", padding: "12px", width: "fit-content"}}>
                    <QRCode size={250} value={coupon.verification_page_url || window.location.href}/>
                </div>
            </div>
        </section>
    );
};

export default CouponQr;
